import { render, staticRenderFns } from "./ScratchRender.vue?vue&type=template&id=653b1bc6&scoped=true&"
import script from "./ScratchRender.vue?vue&type=script&lang=js&"
export * from "./ScratchRender.vue?vue&type=script&lang=js&"
import style0 from "./ScratchRender.vue?vue&type=style&index=0&id=653b1bc6&scoped=true&lang=scss&"
import style1 from "./ScratchRender.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ScratchRender.vue?vue&type=style&index=2&id=653b1bc6&scoped=true&lang=scss&"
import style3 from "./ScratchRender.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b1bc6",
  null
  
)

export default component.exports